export default function Email() {}

var regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function isEmail(value) {
	return regexp.test(value);
}
//# sourceMappingURL=Email.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/modules/types/Email.js
// module id = 877
// module chunks = 1